import type { PokemonCartItem, PokemonCartSingleItem } from '@/types/cart'
import type { SingleProductOrderItemInfo } from '@/types/order'
import type { Genre } from '@/types/genre'

export const isPokemonCartSingleItem = (item: PokemonCartItem): item is PokemonCartSingleItem => item.productType === 'single' 

// TODO: 他カード種のサポート
export const tranlateToSingleProductOrderItem = (item: PokemonCartSingleItem, genre: Genre): SingleProductOrderItemInfo => {
  const {
    productType,
    inventoryId,
    rank,
    unitPrice,
    orderNum,
    product
  } = item

  return {
    genre,
    productType,
    inventoryId,
    rank,
    unitPrice,
    orderNum,
    inventoryProductId: product.inventory_product_id
  }
};
